module.exports = __webpack_public_path__ + "static/signature-3dad3b23cfd50f22def5a3a1f460dd4e.png";